import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledWrapper = styled(Stack)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(1),
  overflowX: 'auto',
  maxWidth: '85%',
  overflowY: 'clip',
}));

export default StyledWrapper;